import CustomQuickFilterBox from '@components/ag-grid/CustomQuickFilterBox';
import Loading from '@components/atomic/atoms/Loading';
import CustomPaginationMui from '@components/materialComponents/CustomPaginationMui';
import { getProjectStagingTable } from '@lib/api';
import { useQuery } from '@tanstack/react-query';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

interface EntitiesStagingTableProps {
	entityType: string;
	projectId: string;
	subActiveKey: string;
	localeText: any;
	columnDefs: ColDef[];
	defaultColDef: ColDef;
	gridRef: React.RefObject<AgGridReact>;
	onGridReady: (params: any, gridRef: React.RefObject<AgGridReact>) => void;
	sbShow: React.ReactNode;
	batchState: string;
}

const EntitiesStagingTable: React.FC<EntitiesStagingTableProps> = ({
	entityType,
	projectId,
	subActiveKey,
	localeText,
	columnDefs,
	defaultColDef,
	gridRef,
	onGridReady,
	sbShow,
	batchState,
}) => {
	const [entityStaging, setEntityStaging] = React.useState<any[]>();
	const [entityStagingMeta, setEntityStagingMeta] = React.useState<any>({});
	const [isFirstResearch2, setIsFirstResearch2] = React.useState(true);
	const [isRefreshing, setIsRefreshing] = React.useState(false);
	const gridRefStaging = React.useRef<AgGridReact>(null);
	const stagingEntitiesQuery = useQuery({
		queryKey: ['staging-entities', entityType, projectId],
		queryFn: () => getProjectStagingTable(entityType, projectId, 'XLSX'),
		enabled: subActiveKey === 'log-entities' && !!projectId,
		refetchInterval: batchState === 'DOING' ? 5000 : false,
	});

	useEffect(() => {
		if (stagingEntitiesQuery.data) {
			setEntityStaging(stagingEntitiesQuery.data.data);
			setEntityStagingMeta({ meta: stagingEntitiesQuery.data.meta });
		}
	}, [stagingEntitiesQuery.data]);

	return (
		<>
			<>
				<Row className="align-items-center mb-4">
					<Col className="col-4">
						<CustomQuickFilterBox
							tableRef={gridRefStaging}
							dataMeta={entityStagingMeta}
							setData={setEntityStaging}
							dataLength={entityStaging?.length}
							isFirstResearch={isFirstResearch2}
							setIsFirstResearch={setIsFirstResearch2}
							refTable={entityType + 'Staging'}
							isRefreshing={isRefreshing}
							setIsRefreshing={setIsRefreshing}
							isQuickFilterDisabled={false}
							setDataMeta={setEntityStagingMeta}
						/>
					</Col>
				</Row>

				<Row>
					<Col className="col-12 col-xxl-9" id="grid-wrapper">
						{Array.isArray(entityStaging) ? (
							<div className="ag-theme-alpine list-table">
								<AgGridReact
									ref={gridRefStaging}
									columnDefs={columnDefs}
									rowData={entityStaging}
									defaultColDef={defaultColDef}
									domLayout="autoHeight"
									tooltipShowDelay={0}
									tooltipHideDelay={2000}
									tooltipMouseTrack={true}
									onGridReady={(e) => onGridReady(e, gridRefStaging)}
									headerHeight={50}
									rowHeight={50}
									suppressCellFocus={true}
									animateRows={true}
									localeText={localeText}
								/>
								{Object.keys(entityStagingMeta).length > 0 && (
									<CustomPaginationMui
										dataMeta={entityStagingMeta}
										setData={setEntityStaging}
										setDataMeta={setEntityStagingMeta}
										refTable={entityType + 'Staging'}
										setIsFirstResearch={setIsFirstResearch2}
										setIsChangedPagination={() => {}}
									/>
								)}
							</div>
						) : (
							<Loading />
						)}
					</Col>
				</Row>
			</>
		</>
	);
};

export default EntitiesStagingTable;
